import * as Yup from 'yup';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Stack, IconButton, InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// CRYPTO
import sha256 from 'crypto-js/sha256';
import enc from 'crypto-js/enc-hex';

import { useMutation } from '@apollo/client';
import secureLocalStorage  from  "react-secure-storage";

// GRAPHQL
import { LoginGQLFunction } from '../../graphql/LOGIN';

// import { SkiClientContext } from "../../App";
// import { SKIClientSession } from '../../skiclientapi/skiclient_session';
// import { E2eeAddressUtil } from '../../skiclientapi/utils/e2ee_address_util';

import { useTranslation } from 'react-i18next';
// components
import Iconify from '../../components/Iconify';
import { FormProvider, RHFTextField } from '../../components/hook-form';

// ----------------------------------------------------------------------

export default function LoginForm() {
  const { t } = useTranslation();
  // const { skiClientContext, createSkiClientSession } = useContext(SkiClientContext);

  const [login] = useMutation(LoginGQLFunction.LOGIN);
  const navigate = useNavigate();
  // const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const LoginSchema = Yup.object().shape({
    email: Yup.string().email(t('login.email_valid')).required(t('login.email_req')),
    password: Yup.string().required(t('login.password_req')),
  });

  const defaultValues = {
    email: '',
    password: '',
    // remember: true,
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
    setError,
    // clearErrors,
  } = methods;

  const onSubmit = async (input) => {
    secureLocalStorage.clear();
    // const { data, loading, error } = await login({ variables: { email: input.email, password: input.password } });
    // console.log(sha256(input.password).toString(enc.Hex))
    const { data } = await login({
      variables: { email: input.email, password: sha256(input.password).toString(enc.Hex) },
      fetchPolicy: 'network-only',
    });
    const info = data.login;

    if (info.err) {
      console.log(info);
      setError(info.err, { type: 'custom', message: info.msg });
    } else {
      secureLocalStorage.setItem('token', info.token);

      const account = {
        cn: info.cn,
        domain: info.domain,
        displayName: info.adminName,
        adminId: info.adminId,
        preferences: info.preferences,
        photoURL: `/static/mock-images/avatars/avatar_${Math.floor(Math.random() * 8) + 1}.jpg`,
      };
      // convert object to JSON string using JSON.stringify()
      const jsonObject = JSON.stringify(account);
      // save to localStorage
      localStorage.setItem('admin-info', jsonObject);

      // const e2eeAddress = E2eeAddressUtil.parseE2eeAddress(info.e2eeAddress);
      // SKIClientSession.createInstance(e2eeAddress);

      navigate('/dashboard');
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3} sx={{ mb: 4 }}>
        <RHFTextField name="email" label={t('login.email')} shrink autocomplete={'on'} />

        <RHFTextField
          name="password"
          label={t('login.password')}
          type={showPassword ? 'text' : 'password'}
          shrink
          autocomplete
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      {/* <Stack direction="row" sx={{ my: 2 }}>
        <RHFCheckbox name="remember" label="Remember me" />
        <Link variant="subtitle2" underline="hover">
          Forgot password?
        </Link>
      </Stack> */}

      <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
        {t('login.button')}
      </LoadingButton>
    </FormProvider>
  );
}
